<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { SupportTicketStatus } from '@/types/support'
import type { SupportTicketStatus as SupportTicketStatusType } from '@/types/support'

const props = defineProps<{
  status: SupportTicketStatusType
}>()

const { t } = useI18n()

const pillClasses = computed<string>(() => {
  switch (props.status) {
    case SupportTicketStatus.New:
      return 'bg-blue-500/15 border border-blue-500/30 text-blue-400'
    case SupportTicketStatus.Ongoing:
      return 'bg-amber-500/15 border border-amber-500/30 text-amber-400'
    case SupportTicketStatus.WaitingForReply:
      return 'bg-violet-500/15 border border-violet-500/30 text-violet-400'
    case SupportTicketStatus.Closed:
      return 'bg-slate-700/50 border border-slate-600 text-slate-400'
    default:
      return 'bg-slate-700/50 border border-slate-600 text-slate-400'
  }
})

const label = computed<string>(() => t(`support.status.${props.status}`))
</script>

<template>
  <span
    class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
    :class="pillClasses"
  >
    {{ label }}
  </span>
</template>
